module.exports = "<div class=\"container\">\n    <div class=\"intro\">\n        <h2>Services</h2>\n        <p>Open console (F5) to see more</p>\n    </div>\n    <div class=\"row\">\n        <div class=\"col-xs-12 col-md-8 col-md-offset-2\">\n            <app-new-account></app-new-account>\n            <hr>\n            <app-account *ngFor=\"let acc of accounts; let i = index\" [account]=\"acc\" [id]=\"i\"></app-account>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/services/services.component.html
// module id = ./src/app/components/services/services.component.html
// module chunks = main